<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="回款目标月">
                    <el-date-picker
                    size="small"
                    v-model="searcheModel.months"
                    type="monthrange"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="录单时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/payment-count/' + activeName)"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="回款分析" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>

        <el-row class="searchSection">
            <el-col :span="18">
                <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="submitSearch">
                    <el-tab-pane label="部门" name="1"></el-tab-pane>
                    <el-tab-pane label="成员" name="2"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="2" :offset="4">
                <CountConfig v-if="Acs('/count-config/view')" :path="searcheModel.path" :tab="searcheModel.tab"></CountConfig>
            </el-col>
        </el-row>
        <div class="main-bd mg20 pro-visible" v-loading="ratio_loading">
            <h3>回款率(当月目标及完成)</h3>
            <el-table 
            v-if="!ratio_loading"
            :data="ratio_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
            <template v-for="(item, index) in ratio_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="cycle_loading">
            <h3>回款账期分析</h3>
            <el-table 
            v-if="!cycle_loading"
            :data="cycle_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
            <template v-for="(item, index) in cycle_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleView(scope.row, 'cycle')">查看</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>

        <div class="main-bd mg20 pro-visible" v-loading="area_loading">
            <h3>回款区域分析</h3>
            <el-table 
            v-if="!area_loading"
            :data="area_list" 
            border 
            height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
            <template v-for="(item, index) in area_fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleView(scope.row, 'area')">查看</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import PaymentCount from "~/services/PaymentCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  export default {
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            ratio_loading: false,
            ratio_list: [],
            searcheModel: {},
            ratio_fields: [
                {field: 'name', label: '部门丨业务员', width: 200},
                {field: 'pfm_goal', label: '回款目标', prop: 'pfm_goal'},
                {field: 'pfm_finish_amount', label: '回款完成金额', prop: 'pfm_finish_amount'},
                {field: 'pfm_finish_ratio', label: '回款率', type: 'ratio'},
            ],

            cycle_loading: false,
            cycle_list: [],
            searcheModelCycle: {},
            cycle_fields: [
                {field: 'name', label: '回款周期丨部门', width: 200},
                {field: 'total_amount', label: '合同金额', prop: 'total_amount'},
                {field: 'total_amount_ratio', label: '合同金额占比', type: 'ratio'},
                {field: 'order_num', label: '订单数量', prop: 'order_num'},
                {field: 'order_num_ratio', label: '订单数占比', type: 'ratio'},
            ],


            area_loading: false,
            area_list: [],
            searcheModelArea: {},
            area_fields: [
                {field: 'label', label: '地区丨省份', width: 200},
                {field: 'one_month', label: '1个月以内', prop: 'one_month'},
                {field: 'one_two_month', label: '1-2个月', prop: 'one_two_month'},
                {field: 'two_three_month', label: '2-3个月', prop: 'two_three_month'},
                {field: 'three_six_month', label: '3-6个月', prop: 'three_six_month'},
                {field: 'six_twelve_month', label: '6-12个月', prop: 'six_twelve_month'},
                {field: 'one_year_plus', label: '1年以上', prop: 'one_year_plus'},
                {field: 'pfm_finish_amount', label: '回款合计', prop: 'pfm_finish_amount'},
                {field: 'not_finish_amount', label: '未收金额合计', prop: 'not_finish_amount'},
            ],
        };
    },
  
    mounted() {
        
    },
  
    created() {
        this.resetForm();
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                months: Config.getDataTimes('this_month'),
                created_at: [],
                branch_id: "",
                user_id: "",
                path: '/count/saleanalysis',
                tab: 'goal-manage-actual',
                count_type: '1'
            };
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getPaymentRatio(params);

            this.searcheModelCycle = _.clone(params);
            this.getCycleList(this.searcheModelCycle);

            this.searcheModelArea = _.clone(params);
            this.getAreaList(this.searcheModelArea);
        },
    
        getPaymentRatio(params) {
            // loading 动画
            this.ratio_loading = true;
            PaymentCount.getList(params, 'payment-ratio').then((res) => {
                if (res.code == 0) {
                    this.ratio_list = res.data;
                }
                this.ratio_loading = false;
            }).catch((err) => {
                console.error(err);
                this.ratio_loading = false;
            });
        },

        getCycleList(params) {
            // loading 动画
            this.cycle_loading = true;
            PaymentCount.getList(params, 'payment-cycle').then((res) => {
                if (res.code == 0) {
                    this.cycle_list = res.data;
                }
                this.cycle_loading = false;
            }).catch((err) => {
                console.error(err);
                this.cycle_loading = false;
            });
        },

        getAreaList(params) {
            // loading 动画
            this.area_loading = true;
            PaymentCount.getList(params, 'payment-area').then((res) => {
                if (res.code == 0) {
                    this.area_list = res.data;
                }
                this.area_loading = false;
            }).catch((err) => {
                console.error(err);
                this.area_loading = false;
            });
        },
        
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        // 查看
        handleView(row, type) {
            let query = _.clone(this.searcheModel);
            if(row.hasOwnProperty('user_id')){
                query['user_id'] = row.user_id;
            }else{
                query['branch_id'] = row.branch_id;
            }
            if(type == 'cycle'){
                query['cycle'] = row.cycle;
            }else if(type == 'area'){
                if(row.level == 1){
                    query['province_id'] = row.id;
                }else if(row.level == 2){
                    query['province_id'] = row.pid;
                    query['city_id'] = row.id;
                }
            }
            // console.log('查看：', query);
            this.$emit("handleView", query);
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/paymentAnalysis.vue